document.addEventListener('DOMContentLoaded', function () {
  const variantSelector = document.querySelector('[name="id"]');
  const metafieldDisplay = {
    manufacturerCode: document.getElementById('manufacturer-code'),
    frameColor: document.getElementById('frame-color'),
    lensColor: document.getElementById('lens-color'),
  };

  const metafieldContainers = {
    manufacturerCodeContainer: document.getElementById('manufacturer-code-container'),
    frameColorContainer: document.getElementById('frame-color-container'),
    lensColorContainer: document.getElementById('lens-color-container'),
  };

  function updateMetafields(variantId) {
    // Find the hidden div for the selected variant
    const variantElement = document.querySelector(`.variant-metafields[data-variant-id="${variantId}"]`);

    if (variantElement) {
      // Get metafield values, or use empty strings if not available
      const manufacturerCode = variantElement.dataset.manufacturerCode || '';
      const frameColor = variantElement.dataset.frameColor || '';
      const lensColor = variantElement.dataset.lensColor || '';

      // Set the text content for each metafield and hide the container if blank
      if (manufacturerCode) {
        metafieldDisplay.manufacturerCode.textContent = manufacturerCode;
        metafieldContainers.manufacturerCodeContainer.style.display = 'block'; // Show if there is a value
      } else {
        metafieldContainers.manufacturerCodeContainer.style.display = 'none'; // Hide if no value
      }

      if (frameColor) {
        metafieldDisplay.frameColor.textContent = frameColor;
        metafieldContainers.frameColorContainer.style.display = 'block'; // Show if there is a value
      } else {
        metafieldContainers.frameColorContainer.style.display = 'none'; // Hide if no value
      }

      if (lensColor) {
        metafieldDisplay.lensColor.textContent = lensColor;
        metafieldContainers.lensColorContainer.style.display = 'block'; // Show if there is a value
      } else {
        metafieldContainers.lensColorContainer.style.display = 'none'; // Hide if no value
      }
    }
  }

  function initializeMetafields() {
    if (variantSelector && variantSelector.value) {
      updateMetafields(variantSelector.value);
    }
  }

  if (variantSelector) {
    // Add an event listener for variant changes
    variantSelector.addEventListener('change', function () {
      updateMetafields(this.value);
    });

    // Initialize with the currently selected variant after DOM is fully loaded
    initializeMetafields();
  }

  // Fallback: Trigger metafield update when the window is fully loaded (in case of dynamic content)
  window.addEventListener('load', initializeMetafields);
});